module.exports = __webpack_public_path__ + "static/media/Aug_2025_2.94e26877.webp";